import Form from "../models/Form";
import LanguageMapper from "./LanguageMapper";
import FormCategoryMapper from "./FormCategoryMapper";

export default class FormMapper {
public map(data: any) : Form {
        const form : Form = new Form();
        
        form.title = data.Title;
        form.attachmentUrl = data.AttachmentUrl;
        form.videoUrl= data.VideoUrl;
        form.url = data.Url;

        form.language = new LanguageMapper().map(data.Language);
        form.category = new FormCategoryMapper().map(data.Category);
        return form;
    }
}